/**
 * Alineación escalonada exacta para la página Estudio en Mobile (< 860px)
 * Requerimiento de diseño (Figma):
 * 1. El título "Destacados" se alinea (bottom con bottom) con el último cliente ("Ferrero Italia").
 * 2. El título "Servicios" se alinea (bottom con bottom) con el último elemento de "Destacados".
 */

export function initStudioMobileAlign() {
   const farRight = document.querySelector('.s-studio__far-right');
   const farRightTitle = document.querySelector('.s-studio__far-right .s-studio__block-title');
   const lastClient = document.querySelector('.s-studio__list--clients .s-studio__list-item:last-child');
   const services = document.querySelector('.s-studio__services');
   const servicesTitle = document.querySelector('.s-studio__services .s-studio__block-title');
   const lastHighlight = document.querySelector('.s-studio__list--highlights .s-studio__list-item:last-child');

   if (!farRight || !farRightTitle || !lastClient || !services || !servicesTitle || !lastHighlight) return;

   const updateAlignment = () => {
      // Solo en mobile (< 860px)
      if (window.innerWidth >= 860) {
         farRight.style.marginTop = '';
         services.style.marginTop = '';
         return;
      }

      // 1. Resetear márgenes temporales para medir cotas base
      farRight.style.marginTop = '0px';
      services.style.marginTop = '0px';

      // 2. Alinear Destacados (farRight) con la línea del último cliente: bottom con bottom,
      // no top con top, porque el título usa una tipografía/line-height distinta a la lista.
      const lastClientBottom = lastClient.getBoundingClientRect().bottom;
      const farRightTitleBottom = farRightTitle.getBoundingClientRect().bottom;
      const offsetDestacados = Math.round(lastClientBottom - farRightTitleBottom);
      farRight.style.marginTop = `${offsetDestacados}px`;

      // 3. Alinear Servicios con la línea del último elemento de Destacados: bottom con bottom.
      const lastHighlightBottom = lastHighlight.getBoundingClientRect().bottom;
      const servicesTitleBottom = servicesTitle.getBoundingClientRect().bottom;
      const offsetServices = Math.round(lastHighlightBottom - servicesTitleBottom);
      services.style.marginTop = `${offsetServices}px`;
   };

   // Ejecución inicial y en eventos de resize/fuentes cargadas
   updateAlignment();

   window.addEventListener('resize', updateAlignment, { passive: true });
   window.addEventListener('load', updateAlignment);

   if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateAlignment);
   }

   if (window.ResizeObserver) {
      const ro = new ResizeObserver(() => {
         updateAlignment();
      });
      const grid = document.querySelector('.s-studio__grid');
      if (grid) ro.observe(grid);
   }
}
